
import { defineComponent } from 'vue';
// import episodes_data from "@/assets/episodes.json";

export default defineComponent({
  name: 'Player',
  components: {
  },
  computed: {
  },
  data() {
    return {
      episodes_data: [],
      random_episode: null,
      show_title: '',
      show_link: '',
      show_cover_url: '',
      episode_title: '',
      episode_link: '',
      episode_description: '',
      episode_description_html: '',
      episode_art_url: '',
      audio_url: '',
      audio_type: '',
      imgWidth: "200"
    }
  },
  async created() {
    //const foobar = await this.latest();
    this.episodes_data = require('@/assets/episodes.json');
  },
  methods: {
    getRandomEpisode: function () {
      const array = this.episodes_data;
      this.random_episode = array[Math.floor(Math.random() * array.length)]
    },
  },
  watch: {
    random_episode: function (ep){
      this.show_title = ep.show_title
      this.show_link = ep.show_link
      this.show_cover_url = ep.show_cover_url
      this.episode_title = ep.title
      this.episode_link = ep.link
      this.episode_description = ep.description
      this.episode_description_html = ep.description_html
      this.episode_art_url = ep.episode_art_url
      this.audio_url = ep.enclosures[0].url
      this.audio_type = ep.enclosures[0].mime_type
    }
  },
  beforeMount(){
    this.getRandomEpisode()
  },
});
